import { useEffect, useState } from 'react';
import { AlertState, CompleteOperationType, StartOperationType } from '../model/alerts.model';

const IDLE_TIMEOUT = 5 * 1000;

export const initialAlertState: AlertState = {
  operation: null,
  status: 'idle',
  message: '',
  isError: false,
};

export const useAlertStatus = () => {
  const [alertState, setAlertState] = useState<AlertState>(initialAlertState);

  useEffect(() => {
    if (alertState.status === 'complete' || alertState.status === 'error') {
      const timer = setTimeout(() => {
        setAlertState(initialAlertState);
      }, IDLE_TIMEOUT);

      return () => clearTimeout(timer);
    }
  }, [alertState]);

  const startOperation: StartOperationType = (operation, initialMessage) => {
    setAlertState({
      operation,
      status: 'in-progress',
      message: initialMessage,
      isError: false,
    });
  };

  const completeOperation: CompleteOperationType = (operation, message, isError = false) => {
    setAlertState({
      operation,
      status: isError ? 'error' : 'complete',
      message,
      isError,
    });
  };

  return { alertState, startOperation, completeOperation, setAlertState };
};
